import dynamic from 'next/dynamic';
import { ErrorProps } from 'next/error';
import Head from 'next/head';
import { NextPageContext } from 'next';

import { ApiError, MetaProps } from '../shared/api/types';
import { getMetaDataTitle } from '../shared/utils/metaData.utils';

const DynamicErrorScreen = dynamic(() => import('journey/errorScreen'), {
  ssr: false,
});

type ErrorPageProps = ErrorProps & MetaProps;

export default function ErrorPage({ statusCode }: ErrorPageProps) {
  return (
    <>
      <Head>
        <meta name="robots" content="noindex, nofollow" />
        <title>{getMetaDataTitle(statusCode)}</title>
      </Head>
      <DynamicErrorScreen />
    </>
  );
}

ErrorPage.getInitialProps = ({ res, err }: NextPageContext): ErrorPageProps => {
  const statusCode = res?.statusCode ?? err?.statusCode ?? 404;
  const sessionId = err instanceof ApiError ? err.sessionId : '';
  return { statusCode, 'X-Dasl-Session-ID': sessionId };
};
